export type DismissalPolicy = "all" | "explicit" | "none"

/** A composer's guard belongs to its modal, even when another modal is open above it. */
export function createDialogCloseRegistry() {
  let current: (() => void) | undefined
  return {
    get: () => current,
    register: (handler: () => void) => {
      current = handler
      return () => {
        if (current === handler) current = undefined
      }
    },
  }
}

export function requestDialogClose(policy: DismissalPolicy, close: () => void, guard?: () => void) {
  if (policy === "none") return
  ;(guard ?? close)()
}

export function matchesDestructionConfirmation(value: string, expected: string) {
  return value === expected
}

/** Removing a child retains the exact parent entry, including its state and dismissal settings. */
export function popDialogEntry<T>(entries: readonly T[]) {
  return { removed: entries.at(-1), remaining: entries.slice(0, -1), restored: entries.at(-2) }
}
